import { render, staticRenderFns } from "./platformIntroduce.vue?vue&type=template&id=babd1b06&scoped=true"
import script from "./platformIntroduce.vue?vue&type=script&lang=js"
export * from "./platformIntroduce.vue?vue&type=script&lang=js"
import style0 from "./platformIntroduce.vue?vue&type=style&index=0&id=babd1b06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babd1b06",
  null
  
)

export default component.exports